import { createContext, useContext, useState } from "react";

const LoadingContext = createContext({
  isLoading: false,
  setLoading: (bool) => {},
  loadingReason: "",
  setLoadingReason: (reason) => {},
  isLoadingVisible: false,
  setIsLoadingVisible: (visible) => {},
});

export const LoadingContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingReason, setLoadingReason] = useState("");
  const [isLoadingVisible, setIsLoadingVisible] = useState(false);
  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        setLoading: setIsLoading,
        loadingReason,
        setLoadingReason,
        isLoadingVisible,
        setIsLoadingVisible,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error(
      "useLoadingContext must be used within a LoadingContextProvider"
    );
  }
  return context;
};

export default LoadingContext;
